/*
 * Project: LegalPlace assistant
 * File: src/app/continuity.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


/**
 * This class reads params from the href at the entry point,
 * Here we can exlude some rules, and manage additional query params
 */
class LpHrefParams {
  constructor() {
    this.whatContinuity();
  }

  /**
     * Initialize the continuity data from href
     */
  whatContinuity() {
    let section = 0;
    let continueThing = '';
    let isPayment = false;

    const link = document.location.href;
    const params = link.split('?');
    const params0 = params[0].split('#');
    if (params0[0].endsWith('/')) {
      params0[0] = params0[0].slice(0, params0[0].length - 1);
    }
    const components = params0[0].split('/');
    const cLength = components.length;
    // test the l-1
    switch (components[cLength - 1]) {
      case 'checkout':
      case 'paiement':
        isPayment = true;
        continueThing = components[cLength - 2];
        break;
      default:
        if (components[cLength - 1] === 'creer' || components[cLength - 2] === 'creer') {
          section = 1;
          isPayment = false;
          continueThing = '';
        } else {
          // adding the point where the end is a continue thing. 5a7adc56af990
          const regOne = /[a-z0-9]{13}/g;
          if (components[cLength - 1].search(regOne) >= 0) {
            continueThing = components[cLength - 1];
            section = 1;
          } else {
            section = components[cLength - 1];
            switch (components[cLength - 2]) {
              case 'creer':
                isPayment = false;
                break;
              default:
                continueThing = components[cLength - 2];
                break;
            }
          }
        }
        break;
    }

    // Continue thing
    if (continueThing.length === 0 && window.contract_id && window.contract_id.length > 0) {
      continueThing = window.contract_id;
    }

    // this.isPayment(isPayment);
    this.setContinuity(continueThing);
    this.setSection(section);
  }

  /**
     * set if the continuity link is on the payment section
     * @param {boolean} pay
     */
  isPayment(pay) {
    // this.is_payment = pay;
  }

  /**
     * Sets the document unique ID to continue
     * whe it's empty the document is new;
     * @param {string} cont
     */
  setContinuity(cont) {
    this.continue = cont;
  }

  /**
     * set the continue section number,
     * when it's a new document this param is ignored.
     * @param {number} sec
     */
  setSection(sec) {
    this.section = sec;
  }
}

export default LpHrefParams;



// WEBPACK FOOTER //
// ./src/app/continuity.js